'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUseCapture = getUseCapture;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Get the capture state either from an options object or the boolean state
 *
 * @param {Object|Boolean|undefined} options
 *
 * @returns {Boolean}
 */
function getUseCapture(options) {
    if (!options) {
        return false;
    }

    if (typeof options === 'boolean') {
        return options;
    }

    return options.capture || false;
}

exports.default = {
    data: function data() {
        return {
            _domListeners: []
        };
    },


    methods: {
        /**
         * Add an internally tracked event listener
         *
         * @param {EventTarget} element
         * @param {String} type
         * @param {Function} listener
         * @param {Object|Boolean|undefined} options
         * @param {Array<any>} ...args
         */
        addEventListener: function addEventListener(element, type, listener, options) {
            this.$data._domListeners.push({
                element: element,
                type: type,
                listener: listener,
                capture: getUseCapture(options)
            });

            for (var _len = arguments.length, args = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
                args[_key - 4] = arguments[_key];
            }

            element.addEventListener.apply(element, [type, listener, options].concat(_toConsumableArray(args)));
        },


        /**
         * Remove an internally tracked event listener
         *
         * @param {EventTarget} element
         * @param {String} type
         * @param {Function} listener
         * @param {Object|Boolean|undefined} options
         * @param {Array<any>} ...args
         */
        removeEventListener: function removeEventListener(element, type, listener, options) {
            for (var _len2 = arguments.length, args = Array(_len2 > 4 ? _len2 - 4 : 0), _key2 = 4; _key2 < _len2; _key2++) {
                args[_key2 - 4] = arguments[_key2];
            }

            element.removeEventListener.apply(element, [type, listener, options].concat(_toConsumableArray(args)));

            var capture = getUseCapture(options);

            this.$data._domListeners = this.$data._domListeners.filter(function (opts) {
                return opts.element !== element || opts.type !== type || opts.listener !== listener || opts.capture !== capture;
            });
        }
    },

    beforeDestroy: function beforeDestroy() {
        this.$data._domListeners.forEach(function (_ref) {
            var element = _ref.element,
                type = _ref.type,
                listener = _ref.listener,
                capture = _ref.capture;

            element.removeEventListener(type, listener, capture);
        });
    }
};